import styled from "styled-components";

export const UserInfoContainer = styled.div`
    flex: 2;
    display: flex;
    flex-direction: row;
    align-items: center;
    
    &.hasLink {
        cursor: pointer;
    }
`

export const UserInfo = styled.div`
    display: flex;
    flex-direction: column;
`

export const UserInfoLabel = styled.div`
    font-size: 0.6rem;
    font-style: italic;
    margin-bottom: 0.3rem;
`

export const UserInfoName = styled.div`
    font-size: 0.8rem;
    font-weight: 500;
    display: flex;
    flex-direction: row;
    align-items: center;
    
    span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 110px;
    }
`
export const UserImage = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 1rem;
    margin-right: 0.5rem;
    background: ${({ theme }) => theme.newBg3};
    overflow: hidden;
`